import { Thermometer, PoundSterling, Leaf, Phone } from "lucide-react";

const EnergyBanner = () => {
  return (
    <section data-testid="energy-banner" className="relative bg-[#0A0A0A] overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[300px]">
          {/* Content Side */}
          <div className="flex flex-col justify-center px-6 sm:px-8 lg:px-12 py-12 lg:py-16">
            <div className="inline-flex items-center gap-2 bg-[#FF6B00] text-white text-xs font-bold uppercase tracking-wider px-3 py-1 mb-4 w-fit">
              <Leaf className="w-4 h-4" />
              Energy Efficient
            </div>
            
            <h2 
              className="text-3xl sm:text-4xl font-black text-white mb-4 leading-tight"
              style={{ fontFamily: "'Chivo', sans-serif" }}
            >
              A-RATED WINDOWS CAN{" "}
              <span className="text-[#FF6B00]">SAVE YOU MONEY</span>{" "}
              ON YOUR HEATING BILLS
            </h2>
            
            <p className="text-gray-400 mb-6 max-w-lg">
              Upgrade to energy-efficient A-rated double glazing and reduce heat loss by up to 50%. 
              Keep your home warmer in winter and cooler in summer while cutting your energy costs.
            </p>
            
            <div className="flex flex-wrap gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-[#FF6B00]/20 flex items-center justify-center">
                  <Thermometer className="w-5 h-5 text-[#FF6B00]" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Reduce Heat Loss</p>
                  <p className="text-gray-500 text-xs">Up to 50%</p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-[#FF6B00]/20 flex items-center justify-center">
                  <PoundSterling className="w-5 h-5 text-[#FF6B00]" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Lower Energy Bills</p>
                  <p className="text-gray-500 text-xs">Save £££ yearly</p>
                </div>
              </div>
            </div>
            
            <a
              href="tel:07917181597"
              data-testid="energy-banner-cta"
              className="inline-flex items-center gap-2 bg-[#FF6B00] text-white font-bold uppercase text-sm tracking-wide px-8 py-4 hover:bg-[#E65000] transition-all w-fit"
            >
              <Phone className="w-5 h-5" />
              Call Now
            </a>
          </div>
          
          {/* Image Side */}
          <div className="relative h-64 lg:h-auto">
            <img
              src="https://static.wixstatic.com/media/4dd2ec_0e077c66652d4d22b5140327c134eaf1~mv2.jpg/v1/fill/w_605,h_992,al_c,q_85,enc_avif,quality_auto/4dd2ec_0e077c66652d4d22b5140327c134eaf1~mv2.jpg"
              alt="Energy efficient A-rated double glazed windows"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Overlay gradient */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent lg:via-transparent" />
            
            {/* A-Rating Badge */}
            <div className="absolute bottom-6 right-6 bg-green-600 text-white p-4 text-center">
              <p className="text-3xl font-black" style={{ fontFamily: "'Chivo', sans-serif" }}>A</p>
              <p className="text-xs font-bold uppercase tracking-wide">Rated</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnergyBanner;
